// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  paymentPagesDetails: Object,
};

const DeleteSelectedPaymentPage = (props: Props) => {
  const {
    visible,
    close,
    submit,
    paymentPagesDetails,
  } = props;

  const deleteSelectedPaymentPage = () => {
    submit(paymentPagesDetails.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">No, dont deactivate</SpButton>,
        <SpButton onClick={deleteSelectedPaymentPage} type="danger">Yes, deactivate</SpButton>,
      ]}
      title="Deactivate Payment Page"
    >
      <div className="px-4">
        <h6 className="mt-1 mb-2">Are you sure you want to deactivate this Payment Page?</h6>
        <SpH5 className="pb-3">
          <div>{paymentPagesDetails.title ? paymentPagesDetails.title : <>&#8211;</>}</div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteSelectedPaymentPage;
